export default {
  GOOGLE: 'google',
  FACEBOOK: 'facebook'
  // add more here
}
